import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  reset (event: Event): void {
    setTimeout(() => {
      (event.target as HTMLElement).closest('form')?.reset()
    }, 0)
  }
}
